<template>
    <div class="container">
        <b-modal
            :model-value="modalDetalle"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <!-- <div class="text-center">
                {{ labels.title }} {{ infoContrat?.nro_contrato }} 
            </div> -->
            <div class="">
                <!-- <b-button class="md-primary" @click="guardarContrato">{{ labels.save }}</b-button> --> 
                <b-button class="md-accent" @click="cierraModal"><h5>{{ labels.close }}</h5></b-button> 
            </div>
            <div>
                <!-- <pre>{{ infoContrat }}</pre> -->
                <b-row class="text-center">
                    <b-col cols="4">
                        <b-button @click="detalleContrato" class="md-dense md-raised md-primary btn-info">{{ labels.detalle }}</b-button> 
                    </b-col>
                    <b-col cols="4">
                        <b-button @click="activosContrato" class="md-dense md-raised md-primary btn-info">{{ labels.activos }}</b-button> 
                    </b-col>
                    <b-col cols="4">
                        <b-button @click="cuotasContrato" class="md-dense md-raised md-primary btn-info">{{ labels.cuotas }}</b-button> 
                    </b-col>
                </b-row>
                <div v-if="showDetalle" class="mt-2">
                    <b-row class="justify-content-center">
                        <h5>{{ labels.detalleContracto }}</h5> 
                    </b-row>
                    <!-- <b-row>
                        <b-col cols="6" class="pl-5">
                            <h5>{{ labels.nroContrato }}</h5> 
                        </b-col>
                        <b-col cols="6">
                            {{ infoContrat?.nro_contrato }} 
                        </b-col>
                    </b-row> -->
                    <b-row>
                        <b-col cols="6" class="pl-5">
                            <h5>{{ labels.fechaInicial }}</h5> 
                        </b-col>
                        <b-col cols="6">
                            {{ infoContrat?.fecha_inicial }} 
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6" class="pl-5">
                            <h5>{{ labels.fechaFinal }}</h5> 
                        </b-col>
                        <b-col cols="6">
                            {{ infoContrat?.fecha_final }} 
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6" class="pl-5">
                            <h5>{{ labels.valorCanon }}</h5> 
                        </b-col>
                        <b-col cols="6">
                            {{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(infoContrat?.canon_arrendamiento) }} 
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6" class="pl-5">
                            <h5>{{ labels.modalidad }}</h5> 
                        </b-col>
                        <b-col cols="6">
                            {{ typeModalidad }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6" class="pl-5">
                            <h5>{{ labels.frecuencia }}</h5> 
                        </b-col>
                        <b-col cols="6">
                            {{ infoContrat?.frecuencia }} 
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6" class="pl-5">
                            <h5>{{ labels.tipoTasa }}</h5> 
                        </b-col>
                        <b-col cols="6">
                            {{ tipoTasa(infoContrat?.tipo_tasa) }} 
                        </b-col>
                    </b-row>
                </div>
                <div v-if="showActivos" class="mt-2">
                    <!-- <b-row class="justify-content-center">
                        <h5>{{ labels.listaActivos }}</h5> 
                    </b-row> -->
                    <ActivosContrato :numContrato="infoContrat.nro_contrato"></ActivosContrato> 
                </div>
                <div v-if="showCuotas" class="mt-2">
                    <!-- <b-row class="justify-content-center">
                        <h5>{{ labels.cuotas }}</h5> 
                    </b-row> -->
                    <cuotasContrato :numContrato="infoContrat.nro_contrato"></cuotasContrato> 
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import TipoTasa from '../../services/TipoTasas'; 
import ActivosContrato from './ActivosContrato.vue'; 
import CuotasContrato from './CuotasContrato.vue'; 

export default {
    name:'Detalle',
    props:['modalDetalle','infoContrat'],
    components:{
        CuotasContrato,
        ActivosContrato
    },
    data:() => ({
        showDetalle : false,
        showActivos : false,
        showCuotas : false,
        infoTipoTasa : [],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Contrato Nro. ', 
                    detalleContracto : 'Detalle contrato',
                    listaActivos : 'Lista activos',
                    save : "Guardar",
                    close : "Cerrar",
                    detalle : "Detalle",
                    activos : "Activos",
                    cuotas : 'Cuotas',
                    nroContrato : 'Nro. contrato', 
                    fechaInicial : 'Fecha inicial',
                    fechaFinal : 'Fecha final',
                    fechaPago : 'Fecha pago',
                    valorCanon : 'Valor canon',
                    /*actDerUsoBrt : 'Activo por derecho de uso bruto',
                    actDerNeto : 'Activo derecho neto',
                    bajasDerechoUso : 'Bajas derecho de uso',
                    remedPasivPorArrendam : 'Remedición pasivo por arrendamiento',
                    pasivPorArrendamiento : 'Pasivo por arrendamiento',
                    gastoAmortizacion : 'Gasto amorización',
                    gastoIntereses : 'Gasto intereses',
                    pagoArrendamiento : 'Pago arrendamiento',
                    agrupaPagoArrendamiento : 'Agrupación pago arrendamiento',
                    activDerechoUso : 'Activo por derecho de uso',
                    activDerechoUsoNeto : 'Activo por derecho de uso neto',
                    informPasivArriendo : 'Informe pasivo arriendo',
                    amortDerechoUso : 'Amortización por derecho de uso',
                    cambioPasivo : 'Cambio pasivo',
                    tiempoAmortizacion : 'Tiempo amortización',
                    pagoCapital : 'Pago capital',
                    intereses : 'Intereses'*/
                    modalidad : 'Modalidad',
                    frecuencia : 'Frecuencia',
                    tipoTasa : 'Tipo tasa'
                }
            }else{
                return {
                    title : 'Contract no. ', 
                    detalleContracto : 'Contract detail',
                    listaActivos : 'Active List',
                    save : "Save",
                    close : "Close",
                    detalle : "Detail",
                    activos : "Assets",
                    cuotas : 'Quotas',
                    nroContrato : 'Contract number',
                    fechaInicial : 'Starting date',
                    fechaFinal : 'End date',
                    fechaPago : 'Payment date',
                    valorCanon : 'Canon value',
                    /*actDerUsoBrt : 'Gross right-of-use asset',
                    actDerNeto : 'Net right asset',
                    bajasDerechoUso : 'You cancel the right of use',
                    remedPasivPorArrendam : 'Lease liability remeasurement',
                    pasivPorArrendamiento : 'Lease liability',
                    gastoAmortizacion : 'Depreciation expense',
                    gastoIntereses : 'Interest expense',
                    pagoArrendamiento : 'Lease payment',
                    agrupaPagoArrendamiento : 'Lease payment grouping',
                    activDerechoUso : 'Asset for right of use',
                    activDerechoUsoNeto : 'Net right-of-use asset',
                    informPasivArriendo : 'Lease passive report',
                    amortDerechoUso : 'Amortization for right of use',
                    cambioPasivo : 'Passive change',
                    tiempoAmortizacion : 'Amortization time',
                    pagoCapital : 'Capital payment',
                    intereses : 'Interests'*/
                    modalidad : 'Mode',
                    frecuencia : 'Frequency',
                    tipoTasa : 'Rate type'
                }
            }
        },
        typeModalidad(){
            let modalidad = ''
            if(this.infoContrat.modalidad == 'V'){ 
                modalidad = 'Vencida'
            
            }else if(this.infoContrat.modalidad == 'F'){ 
                modalidad = 'Fija'

            }else if(this.infoContrat.modalidad == 'A'){ 
                modalidad = 'Anticipada'
                
            }
            return modalidad
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 

            this.showDetalle = false 
            this.showActivos = false 
            this.showCuotas = false 
        },
        detalleContrato(){
            this.showDetalle = true 

            this.showActivos = false 
            this.showCuotas = false 
        },
        activosContrato(){
            this.showActivos = true 

            this.showDetalle = false 
            this.showCuotas = false 
        },
        cuotasContrato(){
            this.showCuotas = true 

            this.showDetalle = false 
            this.showActivos = false 
        },
        tipoTasa(numTipoTasa){
            // console.log(numTipoTasa); 
            TipoTasa.getAllTipoTasas() 
            .then((res) => { 
                // console.log(res.data.listTipoTasas); 
                this.infoTipoTasa = res.data.listTipoTasas 
            })
            .catch((err) => { 
                console.log(err); 
            })

            const nameTasa = this.infoTipoTasa.find( 
                tipoTasa => tipoTasa.tipo_tasa === numTipoTasa 
            )
            return nameTasa?.descripcion?.trim() ? nameTasa?.descripcion : '' 
        }
    }
}
</script>

<style>

</style>
